<ng-container *ngIf="(emailStatusDetailsService.status$|async) as status">
  <dx-popup
    *ngIf="status.display"
    [visible]="status.display"

    [showTitle]="true"
    [showCloseButton]="true"

    width="80%"
    height="80%"

    (onHidden)="closePopup()"
    (close)="closePopup()"

  >
    <div *dxTemplate="let data of 'title'" appFlexLayout="row">
      <h2 appFlex="noshrink">{{ status.title }} ({{ campaignUuid }}/{{ waveUuid }})</h2>
      <span appFlex="grow"></span>
      <button mat-icon-button class="mr-0 mr-sm-16" style="margin-top: 10px" (click)="closePopup()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div *dxTemplate="let data of 'content'">
      <div class="status-popup-container">

        <div *ngIf="status.refresh || status.downloadInfo.isDownloading" class="loading">
          <ng-container *ngIf="status.refresh && !status.downloadInfo.isDownloading">
            <h4>Refreshing...</h4>
          </ng-container>
          <ng-container *ngIf="!status.refresh && status.downloadInfo.isDownloading">
            <h4>Downloading...</h4>
            <dx-progress-bar
              [width]="'70%'"
              [min]="0"
              [max]="status.downloadInfo.progress.max"
              [value]="status.downloadInfo.progress.value"
              [statusFormat]="progressBarStatusFormat"
            ></dx-progress-bar>
          </ng-container>
        </div>

        <ng-container *ngIf="!status.refresh && !status.downloadInfo.isDownloading">
          <div class="hasData">
            <div class="grid-container">
              <app-generic-list
                [canRefresh]="false"
                [dataSource]="(emailStatusDetailsService.data$|async)"
                keyExpr="_id"

                [canExportExcel]="true"
                [exportFileName]="status.title+'-'+campaignUuid+'-'+waveUuid"

                [columns]="columns"

                [multipleOnly]="modeSelectSelected?.value"

                (selectionChanged)="onSelectionChanged($event)"
              >
              </app-generic-list>
            </div>
            <div *ngIf="curSelection?._id" class="details">

              <ejs-tab heightAdjustMode='Fill'>

                <e-tabitems>

                  <e-tabitem>
                    <ng-template #headerText>
                      <div>Details</div>
                    </ng-template>
                    <ng-template #content>
                      <app-json-editor [readOnly]="true" [content]="curSelection"></app-json-editor>
                    </ng-template>
                  </e-tabitem>

                  <e-tabitem>
                    <ng-template #headerText>
                      <div>Email</div>
                    </ng-template>
                    <ng-template #content>
                      <iframe class="iframe-preview" [srcdoc]="curMail|safeHtml"></iframe>
                    </ng-template>
                  </e-tabitem>

                </e-tabitems>

              </ejs-tab>


            </div>
          </div>
          <div class="button-bar">
            <div class="left">
              <mat-checkbox [formControl]="modeSelectSelected" class="block">
                Select multiple for resend
              </mat-checkbox>
            </div>
            <div class="right">
              <button
                [disabled]="curEmailsSelected?.length === 0"
                mat-raised-button color="primary"
                (click)="resendBatchSelected()">Resend
              </button>
            </div>
          </div>

        </ng-container>

      </div>
    </div>
  </dx-popup>

</ng-container>
